import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";
import Service from "@/services/LaporanOperasi";
import type { LaporanOperasi } from "@/types/laporan_operasi";


@Module({
  dynamic: true,
  namespaced: true,
  store,
  name: "laporan-operasi"
})
class LaporanOperasiStore extends VuexModule {
  loading = false;
  data: LaporanOperasi = null;
  dataList: LaporanOperasi[] = [];

  @Mutation
  SET_RECORD(val) {
    this.data = val;
  }

  @Mutation
  SET_DATALIST(val: LaporanOperasi[]) {
    this.dataList = val;
  }

  @Mutation
  SET_LOADING(val: boolean) {
    this.loading = val;
  }

  @Mutation
  RESET_STORE() {
    this.data = null;
    this.dataList = [];
  }

  @Action({ rawError: true })
  async getByRegister(registerId): Promise<void> {
    this.SET_LOADING(true);

    const response = await Service.getByRegister(registerId).finally(() => {
      this.SET_LOADING(false);
    });

    this.SET_DATALIST(response?.data);
  }

  @Action({ rawError: true })
  reset(): void {
    this.RESET_STORE();
  }
}

export default getModule(LaporanOperasiStore);
